import { render, staticRenderFns } from "./PainelItens.vue?vue&type=template&id=1fb31f3e&scoped=true"
import script from "./PainelItens.vue?vue&type=script&lang=js"
export * from "./PainelItens.vue?vue&type=script&lang=js"
import style0 from "./PainelItens.vue?vue&type=style&index=0&id=1fb31f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb31f3e",
  null
  
)

export default component.exports